import axios from "axios";
import { hostname } from "./components/Constants";
const instance = axios.create({
  baseURL: hostname,
  timeout: 50000,
});

instance.interceptors.response.use(
  (response) => response, 
  (error) => {
    if (error.response && error.response.status === 401) {      
      localStorage.clear();      
      window.dispatchEvent(new Event("user-unauthorized"));
    }
    return Promise.reject(error);
  }
);
export default instance;